jQuery(function () {
    function handelPopupFormSubmit(form) {
        var submitBtn = form.find('button[type="submit"]');
        submitBtn.prop('disabled', true);
        setTimeout(function () { return submitBtn.prop('disabled', false); }, 3000);
        var url = form.attr('action');
        $.ajax({
            type: 'POST',
            url: url,
            data: form.serialize(),
        }).done(function (response) { return handleAjaxResponse(response); }).fail(function (response) { return handleAjaxResponse(response); });
    }
    function handleAjaxResponse(response) {
        if (response.message) {
            alert(response.message);
        }
        if (response.redirect) {
            document.location.href = response.redirect;
        }
    }
    $('.js-add-contact-dialog').on('click', function () {
        $('#add-contact-dialog').parent().addClass('visible');
    });
    $('.js-edit-contact-dialog').on('click', function () {
        var contactId = $(this).data('contactid');
        $('#edit-contact-' + contactId + '-dialog').parent().addClass('visible');
    });
    $('.js-delete-contact-dialog').on('click', function () {
        var contactId = $(this).data('contactid');
        $('#delete-contact-' + contactId + '-dialog').parent().addClass('visible');
    });
    $('.js-contact-dialog form').on('submit', function (e) {
        e.preventDefault();
        handelPopupFormSubmit($(this));
    });
});
